import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from '@firebase/auth';
import { auth } from '../firebase';
import { Navigate } from 'react-router-dom';

export default function RedirectIfAuthed({ children }: { children: React.ReactNode }): React.ReactElement | null {
  const [user, setUser] = useState<any | null | undefined>(undefined);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  if (user === undefined) return <div>Loading...</div>;
  if (user) return <Navigate to="/home" replace />;
  return <>{children}</>;
}
